"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var useErrorsState = function () {
    var _a = (0, react_1.useState)({}), errors = _a[0], setErrors = _a[1];
    var resetErrorsField = (0, react_1.useCallback)(function (_a) {
        var _b = _a.target.name, name = _b === void 0 ? '' : _b;
        setErrors(function (prevErrors) {
            var _a = prevErrors, _b = name, fieldValue = _a[_b], errorsPart = __rest(_a, [typeof _b === "symbol" ? _b : _b + ""]);
            return errorsPart;
        });
    }, [setErrors]);
    var resetErrors = (0, react_1.useCallback)(function () {
        setErrors({});
    }, [setErrors]);
    return [errors, setErrors, resetErrorsField, resetErrors];
};
exports.default = useErrorsState;
